import { StyleSheet } from '@react-pdf/renderer'

export const pdfStyles = StyleSheet.create({
  tableRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
})
